import { CartLinesUpdateEvent } from '@shopify/events';

const tl = (kurus) => {
  const n = Number(kurus) / 100;
  const tam = Math.floor(n);
  const kr = Math.round((n - tam) * 100);
  return `${tam.toLocaleString('tr-TR')}${kr ? ',' + String(kr).padStart(2, '0') : ''} ₺`;
};

const azHareket = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
/* fiyat değişiminde sayarak geçiş (reduced-motion'da anında) */
function sayarak(el, hedef) {
  if (!el) return;
  const bas = Number(el.dataset.deger || hedef);
  el.dataset.deger = hedef;
  if (azHareket || bas === Number(hedef)) { el.textContent = tl(hedef); return; }
  cancelAnimationFrame(el._k);
  const t0 = performance.now(); const sure = 520;
  const adim = (t) => {
    const o = Math.min(1, (t - t0) / sure); const e = 1 - (1 - o) ** 3;
    el.textContent = tl(o === 1 ? hedef : Math.round((bas + (hedef - bas) * e) / 100) * 100);
    if (o < 1) el._k = requestAnimationFrame(adim);
  };
  el._k = requestAnimationFrame(adim);
  el.classList.remove('is-parla'); void el.offsetWidth; el.classList.add('is-parla');
}

function isGunuEkle(gun) {
  const d = new Date();
  let kalan = gun;
  while (kalan > 0) {
    d.setDate(d.getDate() + 1);
    const g = d.getDay();
    const tatil = ['10-29', '1-1', '4-23', '5-1', '5-19', '7-15', '8-30'].includes(`${d.getMonth() + 1}-${d.getDate()}`);
    if (g !== 0 && g !== 6 && !tatil) kalan -= 1;
  }
  return d.toLocaleDateString('tr-TR', { day: 'numeric', month: 'long', weekday: 'long' });
}

class KitchUrun {
  constructor(kok) {
    this.kok = kok;
    this.$ = (s) => kok.querySelector(s);
    this.$$ = (s) => [...kok.querySelectorAll(s)];
    this.varyantlar = {};
    this.$$('[data-varyant-id],[data-paket],[data-boy],[data-varyant-sec]').forEach((b) => { this.varyantlar[b.dataset.varyant] = { fiyat: b.dataset.fiyat, eski: Number(b.dataset.eski || 0), baslik: b.dataset.baslik }; });
    this.paketler();
    this.ekKartlar();
    this.galeri();
    this.sabit();
    const tarih = this.$('[data-kargo-tarih]');
    if (tarih) tarih.textContent = kok.hasAttribute('data-kompakt') ? `${((s) => s + (/(Eylül|Ekim)$/.test(s) ? "'e" : "'a"))(isGunuEkle(Number(kok.dataset.gun || 3)).split(' ').slice(0, 2).join('\u00a0'))}\u00a0kadar kargoda` : `en geç ${isGunuEkle(Number(kok.dataset.gun || 3))}`;
    const kmp = this.$('[data-kampanya]');
    if (kmp) {
      const bitis = new Date(kmp.dataset.kampanya).getTime();
      const yaz = () => {
        const k = bitis - Date.now();
        if (!(k > 0)) { kmp.hidden = true; return false; }
        const s = Math.floor(k / 1000); const g = Math.floor(s / 86400); const sa = Math.floor((s % 86400) / 3600); const dk = Math.floor((s % 3600) / 60);
        kmp.querySelector('[data-kampanya-kalan]').textContent = `${g ? g + ' gün ' : ''}${String(sa).padStart(2, '0')}:${String(dk).padStart(2, '0')}`;
        kmp.hidden = false; return true;
      };
      if (yaz()) setInterval(yaz, 30000);
    }
    const form = this.$('[data-k-form]');
    form?.addEventListener('submit', (e) => { e.preventDefault(); this.sepete(); });
  }

  paketler() {
    if (this.$('[data-bnd]')) return this.bundle();
    if (this.kok.hasAttribute('data-kompakt')) return this.paketlerKompakt();
    const paketler = this.$$('[data-paket]');
    const sec = (el) => {
      paketler.forEach((p) => { p.classList.toggle('is-on', p === el); p.setAttribute('aria-checked', p === el); });
      const boy = el.querySelector('[data-boy].is-on');
      this.uygula(boy ? boy.dataset.varyant : el.dataset.varyant, el);
    };
    paketler.forEach((el) => {
      el.addEventListener('click', (e) => { if (!e.target.closest('[data-boy]')) sec(el); });
      el.addEventListener('keydown', (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); sec(el); } });
      el.querySelectorAll('[data-boy]').forEach((b) => b.addEventListener('click', () => {
        el.querySelectorAll('[data-boy]').forEach((x) => x.classList.toggle('is-on', x === b));
        sec(el);
      }));
    });
    this.$$('[data-varyant-sec]').forEach((b) => b.addEventListener('click', () => {
      this.$$('[data-varyant-sec]').forEach((x) => x.classList.toggle('is-on', x === b));
      this.uygula(b.dataset.varyant);
    }));
    const ilk = paketler.find((p) => p.classList.contains('is-on'));
    if (ilk) sec(ilk);
  }

  paketlerKompakt() {
    const paketler = this.$$('[data-paket]');
    const gruplar = this.$$('[data-boylar-paket]');
    const hediye = this.$('[data-hediye-satir]');
    const forneau = this.kok.hasAttribute('data-forneau');
    const tek = forneau ? paketler.find((p) => p.dataset.sira === gruplar[0]?.dataset.boylarPaket) : null;
    const sec = (el) => {
      paketler.forEach((p) => { p.classList.toggle('is-on', p === el); p.setAttribute('aria-checked', p === el); });
      if (forneau) this.kok.classList.toggle('is-set', el !== tek);
      else gruplar.forEach((g) => { g.hidden = g.dataset.boylarPaket !== el.dataset.sira; });
      const grup = gruplar.find((g) => g.dataset.boylarPaket === el.dataset.sira);
      const boy = grup?.querySelector('[data-boy].is-on');
      if (hediye && el.dataset.hediye) hediye.textContent = el.dataset.hediye;
      this.uygula(boy ? boy.dataset.varyant : el.dataset.varyant, el);
    };
    /* forneau: seçili set kartına tekrar dokunmak tek tavaya döner */
    const tikla = (el) => sec(forneau && tek && el !== tek && el.classList.contains('is-on') ? tek : el);
    paketler.forEach((el) => {
      el.addEventListener('click', () => tikla(el));
      el.addEventListener('keydown', (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); tikla(el); } });
    });
    gruplar.forEach((g) => g.querySelectorAll('[data-boy]').forEach((b) => b.addEventListener('click', () => {
      g.querySelectorAll('[data-boy]').forEach((x) => { x.classList.toggle('is-on', x === b); x.setAttribute('aria-pressed', String(x === b)); });
      sec(paketler.find((p) => p.dataset.sira === g.dataset.boylarPaket));
    })));
    this.$$('[data-varyant-sec]').forEach((b) => b.addEventListener('click', () => {
      this.$$('[data-varyant-sec]').forEach((x) => x.classList.toggle('is-on', x === b));
      this.uygula(b.dataset.varyant);
    }));
    const ilk = paketler.find((p) => p.classList.contains('is-on'));
    if (ilk) sec(ilk);
  }

  /* Forneau tipi "Setini kur": durum 0 = tek tava (boy seçilir), 1 = 2'li set, 2 = 3'lü set (gerçek varyantlar);
     aksesuarlar ayrı satır olarak sepete eklenir. */
  bundle() {
    const pk = this.$$('[data-paket]');
    const seg = this.$('[data-boylar-paket]');
    const boylar = seg ? [...seg.querySelectorAll('[data-boy]')] : [];
    const hediye = this.$('[data-hediye-satir]'); const segNot = this.$('[data-seg-not]'); const segNotIlk = segNot?.textContent || '';
    const bas = this.$('[data-bnd-bas]'); const alt = this.$('[data-bnd-alt]');
    const arti = this.$('[data-bnd-arti]'); const eksi = this.$('[data-bnd-eksi]');
    this.ekler = new Map();
    let durum = Math.max(0, pk.findIndex((p) => p.classList.contains('is-on')));
    const ciz = () => {
      const el = pk[durum];
      pk.forEach((p) => p.classList.toggle('is-on', p === el));
      const boy = boylar.find((b) => b.classList.contains('is-on'));
      this.kok.classList.toggle('is-set', durum > 0);
      if (seg && boy) seg.style.setProperty('--i', boylar.indexOf(boy));
      if (segNot) segNot.textContent = durum ? el.dataset.setBoy : segNotIlk;
      this.$$('[data-cubuk]').forEach((c) => c.classList.toggle('is-dolu', durum >= Number(c.dataset.cubuk)));
      if (bas) bas.textContent = el.dataset.sonrakiBas; if (alt) alt.textContent = el.dataset.sonrakiAlt;
      if (arti) arti.hidden = durum >= pk.length - 1; if (eksi) eksi.hidden = durum === 0;
      this.$('[data-bnd-tava]')?.classList.toggle('is-on', durum > 0);
      if (hediye && el.dataset.hediye) hediye.textContent = el.dataset.hediye;
      this.uygula(durum === 0 && boy ? boy.dataset.varyant : el.dataset.varyant, el);
    };
    boylar.forEach((b) => b.addEventListener('click', () => {
      boylar.forEach((x) => { x.classList.toggle('is-on', x === b); x.setAttribute('aria-pressed', String(x === b)); });
      durum = 0; ciz();
    }));
    arti?.addEventListener('click', () => { durum = Math.min(pk.length - 1, durum + 1); ciz(); });
    eksi?.addEventListener('click', () => { durum = Math.max(0, durum - 1); ciz(); });
    ciz();
  }

  /* aksesuar ekle kartları (paketli ve paketsiz ürünlerde): ayrı satır olarak sepete gider, buton fiyatına eklenir */
  ekKartlar() {
    this.ekler = this.ekler || new Map();
    this.$$('[data-ek]').forEach((k) => k.querySelector('[data-ek-btn]').addEventListener('click', (e) => {
      const b = e.currentTarget; const id = k.dataset.ekVaryant;
      if (this.ekler.has(id)) this.ekler.delete(id); else this.ekler.set(id, Number(k.dataset.ekFiyat));
      const on = this.ekler.has(id); k.classList.toggle('is-on', on); b.setAttribute('aria-pressed', String(on));
      if (this._son) this.uygula(...this._son); else this.uygula(this.$('[data-varyant-id]').value);
    }));
  }

  uygula(id, paket) {
    this._son = [id, paket];
    this.$('[data-varyant-id]').value = id;
    const v = this.varyantlar[id];
    if (!v) return;
    if (paket) { const fe = paket.querySelector('[data-paket-fiyat]'); if (fe) fe.textContent = tl(v.fiyat); }
    sayarak(this.$('[data-fiyat]'), Number(v.fiyat));
    this.$('[data-sabit-fiyat]').textContent = tl(v.fiyat);
    const ek = this.ekler ? [...this.ekler.values()].reduce((a, b) => a + b, 0) : 0;
    this.$$('[data-btn-fiyat]').forEach((e) => { if (!e.dataset.deger) e.dataset.deger = Number(v.fiyat) + ek; sayarak(e, Number(v.fiyat) + ek); });
    const eski = this.$('[data-eski]'); const ind = this.$('[data-indirim]');
    const indirimli = v.eski > Number(v.fiyat);
    if (eski) { eski.hidden = !indirimli; ind.hidden = !indirimli; if (indirimli) { eski.textContent = tl(v.eski); ind.textContent = `%${Math.round(((v.eski - v.fiyat) * 100) / v.eski)} indirim`; } }
    const pe = paket?.querySelector('[data-paket-eski]');
    if (pe && indirimli) pe.textContent = tl(v.eski);
    this.$$('[data-secim-ozet],[data-sabit-ad]').forEach((e) => { e.textContent = v.baslik; });
  }

  async sepete() {
    const btn = this.$('[data-sepete]');
    const hata = this.$('[data-hata]');
    hata.hidden = true;
    const id = this.$('[data-varyant-id]').value;
    const items = [{ id: Number(id), quantity: 1 }, ...[...(this.ekler?.keys() || [])].map((e) => ({ id: Number(e), quantity: 1 }))];
    const bolumler = [...document.querySelectorAll('cart-items-component')].map((e) => e.dataset.sectionId).filter(Boolean);
    btn.disabled = true;
    const kok = window.Shopify?.routes?.root || '/';
    const ertelenen = CartLinesUpdateEvent.createPromise();
    this.kok.dispatchEvent(new CartLinesUpdateEvent({ action: 'add', context: 'product', lines: items.map((x) => ({ merchandiseId: String(x.id), quantity: 1 })), promise: ertelenen.promise }));
    try {
      const yanit = await fetch(`${kok}cart/add.js`, {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items, sections: bolumler.join(',') }),
      }).then((r) => r.json());
      const sepet = await fetch(`${kok}cart.js`).then((r) => r.json());
      const detail = { items: sepet.items, source: 'kitch-urun', sourceId: this.kok.id, itemCount: items.length, productId: String(this.kok.dataset.urun), sections: yanit.sections, didError: Boolean(yanit.status) };
      ertelenen.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(sepet), detail });
      if (yanit.status) { hata.textContent = yanit.description || yanit.message || 'Sepete eklenemedi, tekrar dene.'; hata.hidden = false; return; }
      window.kitchSepetZipla?.();
      btn.classList.add('is-tamam'); setTimeout(() => btn.classList.remove('is-tamam'), 1800);
      if (!document.querySelector('cart-drawer-component')) window.location.href = `${kok}cart`;
    } catch (e) {
      ertelenen.reject(e);
      hata.textContent = 'Bağlantı sorunu oldu, tekrar dene.';
      hata.hidden = false;
    } finally {
      btn.disabled = false;
    }
  }

  galeri() {
    const ana = this.$('[data-galeri-ana]');
    if (!ana) return;
    const kareler = [...ana.children];
    const kucukler = this.$$('[data-kucuk]');
    const sayac = this.$('[data-sayac]');
    const isaretle = (i) => {
      kucukler.forEach((k, j) => k.classList.toggle('is-on', j === i));
      if (sayac) sayac.textContent = `${i + 1} / ${kareler.length}`;
      this.aktif = i;
    };
    const git = (i) => {
      const n = (i + kareler.length) % kareler.length;
      ana.scrollTo({ left: kareler[n].offsetLeft - ana.offsetLeft, behavior: 'smooth' });
      isaretle(n);
    };
    this.aktif = 0;
    ana.addEventListener('scroll', () => isaretle(Math.round(ana.scrollLeft / ana.clientWidth)), { passive: true });
    kucukler.forEach((k) => k.addEventListener('click', () => git(Number(k.dataset.kucuk))));
    this.$$('[data-ok]').forEach((b) => b.addEventListener('click', () => git(this.aktif + Number(b.dataset.ok))));
    // tıkla-büyüt: galeri görseli tam ekran (dialog), ok tuşları ve kaydırma ile gezinme
    const resimler = kareler.map((k) => k.querySelector('img')).filter(Boolean);
    if (resimler.length) {
      const dlg = document.createElement('dialog');
      dlg.className = 'k-zoom';
      dlg.innerHTML = '<button type="button" class="k-zoom__kapat" aria-label="Kapat">✕</button><button type="button" class="k-zoom__ok k-zoom__ok--sol" aria-label="Önceki">‹</button><button type="button" class="k-zoom__ok k-zoom__ok--sag" aria-label="Sonraki">›</button>';
      document.body.append(dlg);
      const zi = document.createElement('img'); let zs = 0;
      const ekle = () => { if (!zi.isConnected) dlg.querySelector('.k-zoom__ok--sol').after(zi); };
      const goster = (i) => { zs = (i + resimler.length) % resimler.length; const r = resimler[zs]; zi.src = (r.currentSrc || r.src).replace(/width=\d+/, 'width=2000'); zi.alt = r.alt; };
      resimler.forEach((r, i) => {
        r.style.cursor = 'zoom-in'; r.tabIndex = 0; r.setAttribute('role', 'button'); r.setAttribute('aria-label', `${r.alt || 'Görsel'} · büyüt`);
        const ac = () => { ekle(); goster(i); dlg.showModal(); };
        r.addEventListener('click', ac);
        r.addEventListener('keydown', (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); ac(); } });
      });
      dlg.querySelector('.k-zoom__kapat').addEventListener('click', () => dlg.close());
      dlg.querySelector('.k-zoom__ok--sol').addEventListener('click', () => goster(zs - 1));
      dlg.querySelector('.k-zoom__ok--sag').addEventListener('click', () => goster(zs + 1));
      dlg.addEventListener('click', (e) => { if (e.target === dlg) dlg.close(); });
      dlg.addEventListener('keydown', (e) => { if (e.key === 'ArrowLeft') goster(zs - 1); if (e.key === 'ArrowRight') goster(zs + 1); });
    }
  }

  sabit() {
    const s = this.$('[data-sabit]');
    const btn = this.$('[data-sepete]');
    if (!s || !btn) return;
    const io = new IntersectionObserver(([g]) => {
      const goster = !g.isIntersecting && g.boundingClientRect.top < 0 && window.scrollY > 400;
      s.classList.toggle('is-on', goster);
      s.setAttribute('aria-hidden', String(!goster));
      s.querySelector('[data-sabit-btn]').tabIndex = goster ? 0 : -1;
    });
    io.observe(btn);
    window.addEventListener('scroll', () => { const r = btn.getBoundingClientRect(); const goster = r.bottom < 0 && window.scrollY > 400; s.classList.toggle('is-on', goster); s.setAttribute('aria-hidden', String(!goster)); }, { passive: true });
    s.querySelector('[data-sabit-btn]').addEventListener('click', () => this.sepete());
  }
}

document.querySelectorAll('[data-k-urun]').forEach((k) => { if (!k.kitch) k.kitch = new KitchUrun(k); });

